import { render, staticRenderFns } from "./FeeReceiverField.vue?vue&type=template&id=bbd89450"
import script from "./FeeReceiverField.vue?vue&type=script&lang=js"
export * from "./FeeReceiverField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports